// src/components/music/parts/StarfieldBackground.jsx

import { useMemo } from 'react';

const seededRandom = (seed) => {
  let value = seed;
  return () => {
    value = (value * 9301 + 49297) % 233280;
    return value / 233280;
  };
};

const LAYERS = [
  { seed: 101, count: 120, size: 1, duration: '50s' },
  { seed: 202, count: 60, size: 2, duration: '100s' },
  { seed: 303, count: 25, size: 3, duration: '150s' },
];

const buildShadow = (rand, count) => {
  const points = [];
  for (let i = 0; i < count; i++) {
    const x = Math.floor(rand() * 2000);
    const y = Math.floor(rand() * 2000);
    points.push(`${x}px ${y}px #fff`);
    points.push(`${x}px ${y + 2000}px #fff`);
  }
  return points.join(', ');
};

export default function StarfieldBackground() {
  const layers = useMemo(
    () =>
      LAYERS.map(({ seed, count }) => ({
        shadow: buildShadow(seededRandom(seed), count),
      })),
    []
  );

  return (
    <div className="starfield-bg" aria-hidden="true">
      {layers.map((layer, i) => (
        <div
          key={i}
          className="star-layer"
          style={{
            width: LAYERS[i].size,
            height: LAYERS[i].size,
            boxShadow: layer.shadow,
            animationDuration: LAYERS[i].duration,
          }}
        />
      ))}
    </div>
  );
}
